import { notFound } from 'next/navigation';

import { getChannel, getDocument } from '@lib/server';
import type { Aggregator, Offer } from '@types';

export async function getBrandOffersPageData(domain: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const { fields } = await getDocument<Aggregator>('aggregator', channel.micrositeData[0].id, {
    tags: [channel.channelId],
    depth: 0,
    select: ['fields.brandOffers', 'fields.id', 'fields.name'],
  });

  if (!fields) notFound();

  const offers = [];
  if (fields.brandOffers) {
    for (const offer of fields.brandOffers) {
      try {
        const { fields } = await getDocument<Offer>('promotionsAndOffers', offer.id, {
          tags: [channel.channelId],
          depth: 0,
          status: 'published',
          select: [
            'fields.details',
            'fields.bookingButtonText',
            'fields.offerHeroBanner',
            'fields.seo',
            'fields.dates',
            'fields.settings',
            'fields.landingPageContent',
            'fields.replaceAutomaticPageContent',
          ],
        });
        fields && offers.push(fields);
      } catch (error) {
        console.error(`Error fetching data for offer ${offer.id}:`, error);
      }
    }
  }

  return offers?.filter(Boolean);
}
